import { FC } from 'react';
import { useCountDown } from 'ahooks';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import getLocal from '@/app/utils/getLocal';
import { EU_SITES, euEmailSource } from '@/constants/membersday';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import gtm from '@/utils/gtm';
import Emarsys from '@/components/MembersDay/FY2024/Emarsys';
import { getPrivacyPolicy } from '@/utils/common';

interface FlashSaleCountdownProps {
    timeInfo: {
        secKillStartTime: number;
        secKillEndTime: number;
    };
    handleEnd?: () => void;
}

const FlashSaleCountdown: FC<FlashSaleCountdownProps> = ({ timeInfo, handleEnd }) => {
    const { useLang, getSystemTime } = useGlobal();
    const { locale } = getLocal();
    const { t } = useLang('membersday.activity.flashsale');
    const { t: _t } = useLang('membersday.subscribe');

    const { secKillisBegin } = useMembersStore();
    const [, formattedRes] = useCountDown({
        // leftTime: now - Number(startTime),
        leftTime: secKillisBegin ? timeInfo.secKillEndTime - getSystemTime() : timeInfo.secKillStartTime - getSystemTime(),
        onEnd: () => handleEnd && handleEnd(),
    });
    const { days, hours, minutes, seconds } = formattedRes;
    const handleCompletion = (val: number) => (val < 10 ? `0${val}` : val);

    const successCallBack = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: _t('btnText'),
                status: 'success',
                tag: 'Agree',
            });
        } catch (e) {
            console.error(e);
        }
    };

    const errorCallback = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_submit',
            button_name: _t('btnText'),
            status: 'fail',
            tag: 'Agree',
        });
    };

    if (!secKillisBegin && EU_SITES.includes(locale)) {
        return (
            <div className={styled.flashSaleEmail}>
                <Emarsys
                    source={euEmailSource.flashSale}
                    submitText={_t('btnText')}
                    placeholder={_t('placeholder')}
                    successCallback={successCallBack}
                    errorCallback={errorCallback}
                />
                <p className="protocol">
                    {_t.rich('protocol', {
                        line1: (text: string) => (
                            <a className="link" href={getPrivacyPolicy(locale)} target="_blank" rel="noreferrer">
                                {text}
                            </a>
                        ),
                        line2: (text: string) => (
                            <a className="link" href={`https://${locale}.ecoflow.com/policies/terms-of-service`} target="_blank" rel="noreferrer">
                                {text}
                            </a>
                        ),
                    })}
                </p>
            </div>
        );
    }

    return (
        <div className={styled.flashSaleCountdown}>
            <div>
                <span className="time">{handleCompletion(days)}</span>
                <span>{t('days')}</span>
            </div>
            <span className="colon">:</span>
            <div>
                <span className="time">{handleCompletion(hours)}</span>
                <span>{t('hours')}</span>
            </div>
            <span className="colon">:</span>
            <div>
                <span className="time">{handleCompletion(minutes)}</span>
                <span>{t('minutes')}</span>
            </div>
            <span className="colon">:</span>
            <div>
                <span className="time">{handleCompletion(seconds)}</span>
                <span>{t('seconds')}</span>
            </div>
        </div>
    );
};

export default FlashSaleCountdown;
